// extracted by mini-css-extract-plugin
export var form = "_ei-0";